import { BlogRepository } from '../../domain/repositories/blog.repository';

export const blogServices = (repository: BlogRepository): BlogRepository => ({
  getBlogs: async () => {
    return repository.getBlogs();
  }
});
